(() => {
const init = () => {
  'use strict';
  const panel = document.querySelector('[data-evasion-edition]');
  if (!panel || panel.dataset.editionReady === 'true') return;
  panel.dataset.editionReady = 'true';
  let config, media, live;
  try {
    config = JSON.parse(panel.querySelector('[data-edition-config]').textContent);
    media = JSON.parse(panel.querySelector('[data-edition-media]').textContent);
    live = JSON.parse(panel.querySelector('[data-edition-live]').textContent);
  } catch { return; }
  const preopeningLocked = document.documentElement.dataset.roscoffPreopeningLocked !== 'false';
  const purchase = panel.querySelector('[data-roscoff-purchase]');
  const price = panel.querySelector('[data-edition-price]');
  const state = panel.querySelector('[data-edition-state]');
  const root = panel.closest('.evasion-edition');
  const main = root.querySelector('.artwork-main-image');
  const previews = root.querySelector('[data-edition-previews]');
  const preview = root.querySelector('[data-edition-preview]');
  const image = root.querySelector('[data-edition-mockup-image]');
  const dialog = root.querySelector('[data-edition-dialog]');
  const dialogImage = root.querySelector('[data-edition-dialog-image]');
  let previousOverflow;
  const mobileMedia = matchMedia('(max-width: 767px), (hover: none), (pointer: coarse)');
  const updateMainAccessibility = () => {
    if (mobileMedia.matches) {
      main.removeAttribute('role'); main.removeAttribute('tabindex'); main.removeAttribute('aria-label');
    } else {
      main.setAttribute('role', 'button'); main.setAttribute('tabindex', '0'); main.setAttribute('aria-label', 'Agrandir Évasion');
    }
  };
  mobileMedia.addEventListener('change', updateMainAccessibility);
  updateMainAccessibility();
  ['click', 'keydown'].forEach(type => main.addEventListener(type, event => {
    if (mobileMedia.matches) { if (type === 'keydown') event.preventDefault(); event.stopImmediatePropagation(); }
  }, true));
  preview.addEventListener('click', () => {
    if (presentation !== 'encadre') return;
    dialogImage.src = image.src; dialogImage.alt = image.alt;
    dialog.setAttribute('aria-label', image.alt);
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
  });
  root.querySelector('[data-edition-dialog-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { document.body.style.overflow = previousOverflow; preview.focus({preventScroll: true}); });
  const formats = [...panel.querySelectorAll('[data-edition-format]')];
  const presentations = [...panel.querySelectorAll('[data-edition-presentation]')];
  let format = 64;
  let presentation = 'photo';
  const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
  const linkedOffer = config.offers.find(offer => String(offer.variantId) === requestedVariantId);
  if (linkedOffer) {
    format = linkedOffer.format;
    presentation = linkedOffer.presentation;
  }
  const selected = () => config.offers.find(o => o.format === format && o.presentation === presentation);
  const verified = offer => live.variants.find(v => String(v.id) === offer.variantId);
  const canBuy = offer => {
    const v = verified(offer);
    return !preopeningLocked && config.commercialEnabled === true && config.closed !== true && config.paperConfirmed === true
      && config.fulfillmentConfirmed === true && live.published === true && !!v && v.tracked === true
      && v.policy === 'deny' && v.quantity > 0 && v.available === true && v.price === offer.priceCents;
  };
  function render() {
    const offer = selected();
    if (!offer) return;
    formats.forEach(b => { const yes = Number(b.dataset.editionFormat) === format; b.setAttribute('aria-pressed', String(yes)); b.classList.toggle('is-selected', yes); });
    presentations.forEach(b => { const yes = b.dataset.editionPresentation === presentation; b.setAttribute('aria-pressed', String(yes)); b.classList.toggle('is-selected', yes); });
    price.textContent = new Intl.NumberFormat('fr-FR', {style:'currency',currency:'EUR',maximumFractionDigits:0}).format(offer.priceCents / 100);
    panel.querySelector('[data-edition-dimensions]').textContent = offer.dimensions;
    panel.querySelector('[data-edition-paper]').textContent = 'Papier Canson Infinity Platine Fibre Rag 310 g/m².';
    const framed = presentation === 'encadre';
    panel.querySelector('[data-edition-framing]').hidden = !framed;
    panel.querySelector('[data-edition-unframed]').hidden = framed;
    panel.querySelector('[data-edition-label]').hidden = !framed;
    panel.querySelector('[data-edition-certificate-delivery]').hidden = framed;
    panel.querySelector('[data-edition-delivery-estimate]').textContent = framed
      ? 'Livraison estimée : 10 à 15 jours ouvrés.'
      : 'Livraison estimée : 5 à 10 jours ouvrés';
    const frame = panel.querySelector('[data-edition-frame-dimensions]');
    frame.hidden = !framed;
    frame.textContent = offer.frame ? 'Dimensions du cadre : ' + offer.frame : '';
    if (dialog.open) dialog.close();
    previews.hidden = !framed;
    image.src = media[String(format)];
    image.alt = 'Évasion — tirage ' + offer.dimensions + ', cadre ' + offer.frame;
    image.width = format === 64 ? 1448 : 1536;
    image.height = format === 64 ? 1086 : 1024;
    preview.setAttribute('aria-label', 'Agrandir la présentation encadrée ' + format + ' cm');
    const enabled = canBuy(offer);
    const exhausted = config.closed === true && config.finalAssignedCount === config.editionSize
      && config.offers.every(o => verified(o)?.quantity === 0);
    state.textContent = exhausted ? 'Édition limitée épuisée — 30/30 exemplaires'
      : config.closed === true ? 'Ventes suspendues'
      : preopeningLocked || !config.commercialEnabled ? 'Ouverture en préparation'
      : verified(offer)?.quantity > 0 ? 'Édition limitée à 30 exemplaires' : 'Cette présentation est momentanément indisponible';
    purchase.dataset.purchaseEnabled = String(enabled);
    purchase.dataset.variantId = offer.variantId;
    purchase.querySelector('[name="id"]').value = offer.variantId;
    purchase.querySelector('[data-edition-format-property]').value = offer.dimensions;
    purchase.querySelector('[data-edition-presentation-property]').value = offer.label;
    purchase.querySelector('[name="quantity"]').value = '1';
    purchase.querySelector('[data-cart-add]').disabled = !enabled;
    purchase.querySelector('[data-cart-feedback]').textContent = '';
    purchase.querySelector('[data-cart-success-link]').hidden = true;
    purchase.dispatchEvent(new CustomEvent('roscoff:configuration'));
  }
  formats.forEach(b => b.addEventListener('click', () => { format = Number(b.dataset.editionFormat); render(); }));
  presentations.forEach(b => b.addEventListener('click', () => { presentation = b.dataset.editionPresentation; render(); }));
  purchase.addEventListener('submit', event => {
    if (!selected() || !canBuy(selected())) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  render();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
else init();
})();